import c from "./lib/createApi";

/**
 * experiment
 */

const defaultUrl = "/v1/experiment";

export default {
  getExperimentList : c("GET", defaultUrl + "/get-experiment-list", true), // [experiment - 0] 전체 실험타입 조회
  getDefalutExperiment : c("GET", defaultUrl + "/get-default-experiment", true), // [experiment - 1] 기본 실험타입 조회
  getExperiment : c("GET", defaultUrl + "/get-experiment", true), // [experiment - 2] 해당 실험타입 조회
  createExperiment : c("POST", defaultUrl + "/create-experiment", true), // [experiment - 3] 실험타입 생성
  updateExperiment : c("PUT", defaultUrl + "/update-experiment", true), // [experiment - 4] 실험타입 수정
  deleteExperiment : c("DELETE", defaultUrl + "/delete-experiment", true), // [experiment - 5] 실험타입 삭제
  copyExperiment : c("POST", defaultUrl + "/copy-experiment", true), // [experiment - 6] 해당 실험타입 복사
  saveExperimentData : c("POST", defaultUrl + "/save-experiment-data", true), // [experiment - 7] 실험결과 저장
  getExperimentData : c("GET", defaultUrl + "/get-experiment-data", true), // [experiment - 8] 최신 실험결과 조회
  getAllExperimentValue : c("GET", defaultUrl + "/get-all-experiment-value", true), // [experiment - 9] 모든 실험타입,기본값 조회
  downloadExcelTemplate: c("GET", defaultUrl + "/download-excel-template", true),// [experiment - 10] 엑셀템플릿 다운로드
  uploadExcel: c("POST", defaultUrl + "/upload-excel", true),// [experiment - 11] 엑셀업로드
  history : {
    get: c("GET", defaultUrl + "/history/cell", true),// [experiment - 12] Cell 변경이력
    getVersionList: c("GET", defaultUrl + "/history/versionList", true),// [experiment - 13] 실험입력 버전이력 리스트
    getVersionHistoryData: c("GET", defaultUrl + "/history/versionData", true),// [experiment - 14] 실험입력 특정버전이력의 실험데이터
  },
  custom : {
    create: c("POST", defaultUrl + "/custom/create", true),// [experiment - 15] 실험입력 사용자 커스텀 추가
    get: c("GET", defaultUrl + "/custom/get", true),// [experiment - 16] 실험입력 사용자 커스텀 가져오기
  },
  downloadVisualizationExcel : c("POST", defaultUrl + "/download-visualization-excel", true),// [experiment - 17] 시각화 엑셀 다운로드 -> chart로 인하여 backend에서 생성
  getNodekeyExperimentData : c("GET", defaultUrl + "/get-nodekey-experiment-data", true), // [experiment - 18] 특정 노드의 Key를 사용하여 해당 속성의 최신 실험결과 조회
  downloadVocabClassExcel: c("GET", defaultUrl + "/download-vocab-class-excel", true),// [experiment - 19] 엑셀 다운로드 header에 어휘번호,class 추가
  getExperimentDataByPropertyAndProcess: c("GET", `${defaultUrl}/experiment-data/by-property-and-process`, true), // [experiment-20] 사전 속성 id와 공정도 id를 사용해서 실험 데이터 조회
};
